module.exports = __webpack_public_path__ + "static/monetize-tile-4-3-5e84cdbc6b35ccf895864e2e0908fe77.png";